<template>
  <v-container grid-list-md v-if="this.$store.getters.programsFetched">

    <v-tabs
      v-model="currentTab"
      color="grey darken-2"
      dark
      slider-color="orange"
      show-arrows
    >
      <v-tab>
        Applications
      </v-tab>
      <v-tab-item>
          <app-list/>
      </v-tab-item>

      <v-tab>
        Registrations
      </v-tab>
      <v-tab-item>
          <registrations/>
      </v-tab-item>

      <v-tab>
        Referrers
      </v-tab>
      <v-tab-item>
          <referrers/>
      </v-tab-item>

    </v-tabs>


  </v-container>
</template>

<script>
import AppList from './AppList.vue'
import Registrations from './Registrations.vue'
import Referrers from './Referrers.vue'

export default {
  data: () => ({
    currentTab: 0,
    loading: true,
    valid: true,
    authenticatedUser: null
  }),
  components: {
    AppList,
    Registrations,
    Referrers
  },
  methods: {
  },
  created() {
    this.authenticatedUser = this.$store.getters.getAuthenticatedUser
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/AppAdminView.vue